import { render, staticRenderFns } from "./xtSelector.vue?vue&type=template&id=68485624&scoped=true&"
import script from "./xtSelector.vue?vue&type=script&lang=js&"
export * from "./xtSelector.vue?vue&type=script&lang=js&"
import style0 from "./xtSelector.vue?vue&type=style&index=0&id=68485624&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68485624",
  null
  
)

export default component.exports